<script>
    import { h } from "vue";
    export default {
        setup() {
            return () => h("span", " ");
        }
    };
</script>
